<!--v-for="item in jinNangList"
        :key="item"-->
<template>
  <!-- 个人介绍 -->
  <base-panel :title="title" :hide-button="true" class="panel-wrapper">
    <ul class="jinnangs">
      <router-link
        class="jinnang"
        v-for="item in jinNangList"
        :key="item.jinNangId"
        :to="`/jinnang/${item.jinNangId}`"
      >
        <div class="jinnang-yield">
          <div class="jinnang-yield-label">总收益</div>
          <div
            :class="[
              'jinnang-yield-value',
              getSymbol(item.glYield) > 0 ? 'c1' : 'c3'
            ]"
          >
            {{ item.glYield }}
          </div>
        </div>
        <div class="sale-info">
          <div class="jinnang-name">{{ item.title }}</div>
          <div class="jinnang-price">￥{{ item.price }}/月</div>
        </div></router-link
      >
    </ul>
  </base-panel>
</template>

<script>
import BasePanel from '@/components/BasePanel/BasePanel'
export default {
  name: 'JinNangPanel',
  components: { BasePanel },
  props: {
    title: {
      type: String,
      required: false,
      default: '他的热卖锦囊'
    },
    jinNangList: {
      type: Array,
      required: true
    }
  },
  methods: {
    getSymbol(yieldStr) {
      return parseFloat(yieldStr)
    }
  }
}
</script>

<style lang="scss" scoped>
.panel-wrapper {
  margin-top: 30px;
}

.jinnangs {
  display: flex;
  flex-direction: column;
}
.jinnang {
  display: flex;
  flex-direction: row;
  margin-left: 25px;
  margin-top: 25px;
  margin-bottom: 25px;
  text-decoration: none;
}
.jinnang-yield {
  text-align: center;
  padding-left: 30px;
}
.jinnang-yield-label {
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 20px;
  letter-spacing: 1px;
  color: #262626;
}
.jinnang-name {
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 20px;
  letter-spacing: 1px;
  color: #262626;
}

.jinnang-yield-value {
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  line-height: 30px;
  letter-spacing: 1px;
}
.sale-info {
  margin-left: 60px;
  text-align: center;
}
.jinnang-price {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 30px;
  letter-spacing: 1px;
  color: #858585;
}
</style>
